import React, {FC} from "react"
import Greeting from "@irati/ui/src/Greeting/Greeting"
import {H4} from "@irati/ui/src/Typography"
import authentication from "@irati/auth"

import {StyledGreeting} from "./styled"

const HomePageGreeting: FC = () => {
  const user = authentication.user()
  return (
    <StyledGreeting>
      <H4>
        <Greeting user={user} />
      </H4>
    </StyledGreeting>
  )
}

export default HomePageGreeting
